import { useState } from "react";
import { subscribeEmail } from "./requests";

export const useSubscribeEmail = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const clearErrorMessage = () => setErrorMessage("");
  const handleSubmit = async (event) => {
    event.preventDefault();
    const email = new FormData(event.target).get("email");

    if (!event.target.checkValidity()) {
      setErrorMessage("Please enter a valid email address");
      return;
    }

    try {
      await subscribeEmail(email);
      setSuccessMessage("Please check your inbox for your special offer.");
    } catch (error) {
      const responseError = error?.response?.data?.error;
      setErrorMessage(responseError ?? "Please try again later");
    }
  };

  return {
    handleSubmit,
    clearErrorMessage,
    errorMessage,
    successMessage
  };
};
